import Vue from 'vue'
import Router from 'vue-router'
import OrdersView from '@/components/views/OrdersView'
import LoginView from '@/components/views/LoginView'
import UsersView from '@/components/views/UsersView'
import PlanRouteView from '@/components/views/PlanRouteView'
import PageNotFoundView from '@/components/views/PageNotFoundView'
import store from '@/store'
import PermanentPointsView from "../components/views/PermanentPointsView.vue";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/orders',
      name: 'orders',
      component: OrdersView,
      beforeEnter: (to, from, next) => {
        if (!store.getters['auth/isLogged']) router.push({ name: 'login' })
        else next()
      }
    },
    {
      path: '/plan/:routeId?',
      name: 'PlanRoute',
      component: PlanRouteView,
      beforeEnter: (to, from, next) => {
        if (!store.getters['auth/isLogged']) router.push({ name: 'login' })
        else next()
      }
    },
    {
      path: '/permanent-points',
      name: 'PermanentPoints',
      component: PermanentPointsView,
      beforeEnter: (to, from, next) => {
        if (!store.getters['auth/isLogged']) router.push({ name: 'login' })
        else next()
      }
    },
    {
      path: '/',
      redirect: { name: 'orders' }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      beforeEnter: (to, from, next) => {
        if (store.getters['auth/isLogged']) router.push({ name: 'orders' })
        else next()
      }
    },
    {
      path: '/users',
      name: 'users',
      component: UsersView,
      beforeEnter: (to, from, next) => {
        if (!store.getters['auth/isLogged']) router.push({ name: 'login' })
        else if (!store.getters['auth/isAdmin']) router.push({ name: 'orders' })
        else next()
      }
    },
    {
      path: '*',
      name: '404',
      component: PageNotFoundView
    }
  ]
})
export default router